const ar = {
	appName: 'resolvo.me',
	welcomeMessage: 'إدارة وتتبع قراراتك للعام الجديد',
	signInToYourAccount: 'تسجيل الدخول إلى حسابك',
	createYourAccount: 'إنشاء حسابك',
	firstName: 'الاسم الأول',
	lastName: 'اسم العائلة',
	emailAddress: 'البريد الإلكتروني',
	password: 'كلمة المرور',
	confirmPassword: 'تأكيد كلمة المرور',
	signUp: 'سجل',
	signIn: 'تسجيل الدخول',
	processing: 'جار المعالجة...',
	dontHaveAccountSignUp: 'لا تملك حسابًا؟ سجّل',
	alreadyHaveAccountSignIn: 'هل لديك حساب بالفعل؟ سجّل الدخول',
	resetPassword: 'إعادة تعيين كلمة المرور',
	sendResetEmail: 'إرسال بريد إعادة التعيين',
	sending: 'جار الإرسال...',
	rememberMe: 'تذكرني',
	forgotPassword: 'نسيت كلمة المرور؟',
	adminDashboard: 'لوحة المشرف',
	myDashboard: 'لوحتي',
	myProfile: 'ملفي',
	settings: 'الإعدادات',
	signOut: 'تسجيل الخروج',
	addResolution: 'إضافة هدف',
	cancel: 'إلغاء',
	makePrivate: 'اجعل هذا الهدف خاصًا (مشفر)',
	encryptionKey: 'مفتاح التشفير',
	enterEncryptionKey: 'أدخل مفتاحًا آمنًا لتشفير هدفك',
	rememberEncryptionKey: 'تذكر هذا المفتاح! - ستحتاجه لعرض هدفك الخاص',
	type: 'النوع',
	year: 'السنة',
	resolutionText: 'نص الهدف',
	exampleCount: 'مثال: قراءة 20 كتابًا هذا العام',
	exampleBinary: 'مثال: شراء سيارة جديدة',
	exampleMetric: 'مثال: خسارة 10 كجم بحلول نهاية العام',
	startValue: 'قيمة البداية',
	targetValue: 'القيمة المستهدفة',
	unit: 'الوحدة',
	unitExample: 'مثال: كجم، كم، ساعات، USD',
	exampleStreak: 'مثال: شرب 2 لتر ماء كل يوم (سجل يوميًا)',
	currentStreak: 'السلسلة الحالية',
	longestStreak: 'أطول سلسلة',
	never: 'أبدًا',
	measurements: 'القياسات',
	lastLogDate: 'تاريخ آخر تسجيل',
	daysInARow: 'أيام متتالية',
	dailyInARow: 'أيام متتالية',
	weeklyInARow: 'أسابيع متتالية',
	monthlyInARow: 'أشهر متتالية',
	period: 'الفترة',
	daily: 'يومي',
	weekly: 'أسبوعي',
	monthly: 'شهري',
	value: 'القيمة',
	note: 'ملاحظة',
	add: 'إضافة',
	loading: 'جار التحميل...',
	resolutions: 'الأهداف',
	claimAccount: 'يجب أن تطالب بحسابك لإضافة أهداف',
	timeUntilNewYear: 'الوقت حتى العام الجديد',
	contactAdmin: 'اتصل بالمشرف بشأن أهدافك...',
	verifyingLink: 'جاري التحقق من الرابط...',
	invalidLink: 'رابط غير صالح',
	goToLogin: 'الذهاب إلى تسجيل الدخول',
	completeAccountClaim: 'إكمال المطالبة بالحساب',
	emailVerifiedCreatePassword: 'تم التحقق من البريد الإلكتروني! أنشئ كلمة مرور لتأمين حسابك.',
	accountLabel: 'الحساب',
	createPasswordLabel: 'إنشاء كلمة مرور',
	confirmPasswordLabel: 'تأكيد كلمة المرور',
	enterYourPassword: 'أدخل كلمة المرور',
	confirmYourPassword: 'أكد كلمة المرور',
	creatingAccount: 'جار إنشاء الحساب...',
	completeClaim: 'إكمال المطالبة',
	backToLogin: 'العودة إلى تسجيل الدخول',
	passwordMismatch: 'كلمات المرور غير متطابقة',
	passwordTooShort: 'يجب أن تكون كلمة المرور 6 أحرف على الأقل',
	invalidOrExpiredLink: 'رابط التحقق غير صالح أو منتهي الصلاحية',
	linkNotFound: 'لم يتم العثور على رابط التحقق أو انتهت صلاحيته',
	linkExpiredRequestNew: 'انتهت صلاحية رابط التحقق. الرجاء طلب رابط جديد.',
	accountAlreadyClaimed: 'تمت المطالبة بهذا الحساب بالفعل',
	failedToCreateAccount: 'فشل في إنشاء الحساب. الرجاء المحاولة مرة أخرى.',
	claimErrorGeneric: 'حدث خطأ أثناء إكمال المطالبة',
	resolution: 'هدف',
	total: 'الإجمالي',
	overallProgress: 'التقدم العام',
	progress: 'التقدم',
	completed: 'مكتمل',
	complete: 'أكمل',
	'waiting-completion': 'في انتظار الاكتمال',
	ahead: 'متقدم',
	behind: 'متأخر',
	'on-track': 'على المسار',
	failed: 'فشل',
	private: 'خاص',
	decrypt: 'فك التشفير',
	delete: 'حذف',
	backToPlrofile: '← العودة إلى الملف الشخصي',
	customizeProfile: 'خصص ملفك الشخصي وتفضيلاتك',
	displayNameHeading: 'اسم العرض',
	displayNameHelp: 'كيف يظهر اسمك في ملفك الشخصي',
	enterDisplayName: 'أدخل اسم العرض الخاص بك',
	currentlyShowing: 'يتم العرض حاليًا',
	emailPreferences: 'تفضيلات البريد الإلكتروني',
	requiredForReceiving: 'مطلوب لتلقي إشعارات البريد الإلكتروني',
	weeklyStatusEmail: 'البريد الإلكتروني الأسبوعي للحالة',
	emailRequired: '(مطلوب عنوان البريد الإلكتروني)',
	timerStyle: 'نمط المؤقت',
	chooseTimer: 'اختر كيف تريد أن يظهر عداد الوقت',
	selected: 'محدد',
	preview: 'معاينة:',
	saving: 'جار الحفظ...',
	saveSettings: 'حفظ الإعدادات',
	count: 'عدد',
	binary: 'نعم/لا',
	metric: 'مقياس',
	streak: 'سلسلة',
	yes: 'نعم',
	no: 'لا',
	'timer.months': 'أشهر',
	'timer.days': 'أيام',
	'timer.hours': 'ساعات',
	'timer.minutes': 'دقائق',
	'timer.seconds': 'ثواني',
	'timer.monthsShort': 'شهور',
	'timer.daysShort': 'أيام',
	'timer.hoursShort': 'س',
	'timer.minutesShort': 'د',
	'timer.secondsShort': 'ث',
	'timer.monthsShortLower': 'ش',
	'timer.daysShortLower': 'ي',
	'timer.hoursShortLower': 'س',
	'timer.minutesShortLower': 'د',
	'timer.secondsShortLower': 'ث',
	'timer.yearEnded': '🎉 انتهى العام!',
	'timer.option.basic.name': 'سطر واحد بسيط',
	'timer.option.basic.desc': 'تنسيق نظيف وبسيط في سطر واحد',
	'timer.option.card.name': 'بطاقات ملونة',
	'timer.option.card.desc': 'بطاقات ملونة لكل وحدة زمنية',
	'timer.option.clock.name': 'نمط ساعة رقمية',
	'timer.option.clock.desc': 'نمط ساعة رقمية غامق',
	'timer.option.circular.name': 'نمط حلقة التقدم',
	'timer.option.circular.desc': 'مؤشرات تقدم دائرية حديثة',
	'timer.option.flip.name': 'رسوم متحركة FlipCard',
	'timer.option.flip.desc': 'بطاقات متحركة (سطح المكتب فقط)',
	'timer.option.icon.name': 'نص مع أيقونات',
	'timer.option.icon.desc': 'رموز تعبيرية مع نص مختصر',
	resolutionUpdatedSuccessfully: 'تم تحديث الهدف بنجاح!',
	errorUpdatingResolution: 'خطأ في تحديث الهدف',
	failedToUpdateResolution: 'فشل في تحديث الهدف',
	settingsUpdatedSuccessfully: 'تم تحديث الإعدادات بنجاح!',
	errorDeletingResolution: 'خطأ أثناء حذف الهدف',
	failedToDeleteResolution: 'فشل في حذف الهدف',
	failedToUpdateSettings: 'فشل في تحديث الإعدادات',
	settingsSavedSuccessfully: 'تم حفظ الإعدادات بنجاح!',
	failedToSaveSettings: 'فشل في حفظ الإعدادات',
	errorSavingSettings: 'خطأ أثناء حفظ الإعدادات',
	resolutionDeletedSuccessfully: 'تم حذف الهدف بنجاح!',
	// Landing page translations
	landingHeroTitle: 'حوّل أهدافك إلى زخم',
	landingHeroSubtitle:
		'resolvo.me يساعدك على تحديد قرارات ذات معنى، تتبع التقدم بهدف، وتحويل أحلامك إلى عادات دائمة.',
	landingGetStarted: 'ابدأ رحلتك',
	landingLearnMore: 'انظر كيف تعمل',
	landingAndroidComingSoon: '📱 تطبيق أندرويد قادم قريبًا',
	landingAimTitle: 'لماذا resolvo.me؟',
	landingAimDesc:
		'نؤمن بقوة الأهداف الواضحة والمتابعة المستمرة. تم تصميم resolvo.me للأشخاص الذين يريدون النجاح — ليس من خلال الكمال، بل من خلال التقدم.',
	// Core Missions
	landingMission1Title: 'اكسر تراجع فبراير',
	landingMission1Desc: 'تفشل معظم قرارات العام الجديد بحلول فبراير — ليس لأن الأهداف خاطئة، بل لأننا نوقف المتابعة.',
	landingMission2Title: 'حوّل النوايا إلى فعل',
	landingMission2Desc:
		'التغيير الحقيقي لا يأتي من الوعود فقط. إنه يأتي من الخيارات اليومية، والتفكير الأسبوعي، ورؤية تقدمك يتراكم مع الوقت.',
	landingMission3Title: 'بسط العملية',
	landingMission3Desc: 'حدد أهدافك، سجّل تقدمك، احصل على ملاحظات أسبوعية، وشاهد ما يعمل بالفعل.',
	landingMission4Title: 'ابنِ قدرة دائمة',
	landingMission4Desc: 'التغيير الدائم ليس عن الكمال — إنه عن الاتساق.',
	landingFeature1Title: 'أنواع متعددة من الأهداف',
	landingFeature1Desc: 'اختر طريقة التتبع المناسبة لهدفك',
	landingFeature2Title: 'تتبع و تصور',
	landingFeature2Desc: 'شاهد تقدمك عبر رسوم بيانية وسلاسل ورؤى مفيدة',
	landingFeature3Title: 'تحديثات أسبوعية',
	landingFeature3Desc: 'ابقَ مسؤولًا مع ملخصات البريد الإلكتروني الأسبوعية',
	landingFeature4Title: 'آمن و خاص',
	landingFeature4Desc: 'بياناتك مشفرة. أنت تملك أهدافك.',
	landingResolutionTypesTitle: 'أنواع الأهداف',
	landingResolutionTypesSubtitle: 'اختر التنسيق الأنسب لهدفك',
	landingBinaryType: 'ثنائي (نعم/لا)',
	landingBinaryDesc: 'التحقق اليومي البسيط للعادة والروتين',
	landingBinaryExample1: 'شراء سيارة جديدة',
	landingBinaryExample2: 'العثور على وظيفة جديدة',
	landingCountType: 'العد',
	landingCountDesc: 'تتبع عدد المرات التي تقوم فيها بشيء ما',
	landingCountExample1: 'قراءة 20 كتابًا هذا العام',
	landingCountExample2: 'كتابة 50 منشور مدونة هذا العام',
	landingMetricType: 'مقياس',
	landingMetricDesc: 'تتبع تقدم رقمي مع قيمة بداية وقيمة هدف',
	landingMetricExample1: 'خسارة 10 كجم بحلول نهاية العام',
	landingMetricExample2: 'ادخار 5,000 $ هذا العام',
	landingStreakType: 'سلسلة',
	landingStreakDesc: 'ابنِ أيام نجاح متتالية لتعزيز الدافع',
	landingStreakExample1: 'شرب 2 لتر ماء يوميًا',
	landingStreakExample2: 'كتابة 500 كلمة يوميًا لروايتك',
	landingQuote1: 'النجاح هو نتاج العادات اليومية — ليس تحولًا لمرة واحدة.',
	landingQuote1Author: 'جيمس كلير',
	landingQuote2: 'سر التقدم هو البدء.',
	landingQuote2Author: 'مارك توين',
	landingFeaturesTitle: 'ميزات مصممة للنجاح',
	landingFeatureLogging: 'تسجيل بنقرة واحدة',
	landingFeatureLoggingDesc: 'سجل تقدمك في ثوانٍ، من أي مكان',
	landingFeatureHistory: 'سجل التقدم',
	landingFeatureHistoryDesc: 'راجع جميع إدخالاتك واطّلع على مدى تقدمك',
	landingFeatureReminders: 'تذكيرات ذكية',
	landingFeatureRemindersDesc: 'تذكيرات اختيارية لإبقائك على المسار',
	landingFeatureExport: 'تصدير بياناتك',
	landingFeatureExportDesc: 'حمّل بياناتك في أي وقت — إنها ملكك',
	landingCtaTitle: 'هل أنت مستعد لجعل هذا العام الأفضل؟',
	landingCtaDesc: 'انضم إلى آلاف الأشخاص الذين يعملون بالفعل نحو أهدافهم.',
	landingCtaButton: 'أنشئ هدفك الأول',
	landingFooterAbout: 'resolvo.me: بسيط. خاص. مصمم لمن يريد التغيير حقًا.',
	landingFooterContact: 'أسئلة؟ تواصل معنا أو زر التطبيق',
};

export default ar;
